import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from "react-intl";
import API from '../../../utils/API';
import RadioCheck from '../../../components/MessageManager/RadioCheck';
import commonFunctions from '../../../utils/commonFunctions';
import InputValidation from '../../../utils/InputValidation';
import { SIGNAGE_MEDIA } from '../../../utils/constants';
import { use } from 'react';

function AddLink({
  refreshData,
  setSuccess,
  setError,
  closeModal,
  linkItem,
  setLinkItem,
  updatePlaylistsMedia
}) {
  const [name, setName] = useState('');
  const [link, setLink] = useState('');
  const [embedCode, setEmbedCode] = useState('');
  const [mode, setMode] = useState(SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.LINK);
  const [type, setType] = useState(SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_LINK);
  const [nameValid, setNameValid] = useState('');
  const [linkValid, setLinkValid] = useState('');
  const [embedCodeValid, setEmbedCodeValid] = useState('');
  const [modalError, setModalError] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [typeLinkOptions] = useState({ [SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_LINK]: "LINK", [SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_YOUTUBE]: "YOUTUBE", [SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_VIMEO]: "VIMEO" });
  const intl = useIntl();

  /**
    * Reset modal
    */
  function resetModal() {
    setSubmitted(false);
    setModalError('');
    setName('');
    setLink('');
    setEmbedCode('');
    setMode(SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.LINK);
    setType(SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_LINK);
    setNameValid('');
    setLinkValid('');
    setEmbedCodeValid('');
    setLinkItem(null);
  }

  useEffect(() => {
    if (linkItem) {
      setName(linkItem.name);
      setLink(linkItem.content?.urls?.[0] || '');
      setEmbedCode(linkItem.content?.embedCode || '');
      setMode(linkItem.subcategory || SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.LINK);
      setType(linkItem.type || SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_LINK);
    }
  }, [linkItem]);

  useEffect(() => {
    const modalElement = document.getElementById('addLinkModal');
    modalElement.addEventListener('hidden.bs.modal', resetModal);

    return () => {
      modalElement.removeEventListener('hidden.bs.modal', resetModal);
    };
  }, []);

  useEffect(() => {
    if (mode === SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.CODE) {
      setType(SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.CODE);
    } else if (mode === SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.LINK) {
      setType(linkItem?.type && linkItem?.type !== SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.CODE ? linkItem?.type : SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_LINK);
    }
  }, [mode]);

  const validateField = (value, type) => {
    if (InputValidation.validateEmpty(value)) return 'EMPTY_FIELD_ERROR';
    if (type === 'name' && (value.length < 2 || value.length > 36)) return 'LINK_NAME_LENGTH';
    return '';
  };

  const handleChangeName = (e) => {
    const value = e.target.value/*.trim()*/;
    setName(value);
    setNameValid(validateField(value, 'name'));
  };

  const handleChangeLink = (e) => {
    const value = e.target.value/*.trim()*/;
    setLink(value);
    setLinkValid(validateField(value));
  };

  const handleChangeEmbedCode = (e) => {
    const value = e.target.value/*.trim()*/;
    setEmbedCode(value);
    setEmbedCodeValid(validateField(value));
  };

  const isYouTubeUrl = (urlObj) => {
    try {
      return ['youtube.com', 'www.youtube.com', 'youtu.be'].includes(urlObj.hostname);
    } catch (e) {
      console.log(`******errror=${e}`);
      return false; // Not youtube URL
    }
  };
  const isVimeoUrl = (urlObj) => {
    try {
      return ['vimeo.com', 'www.vimeo.com', 'player.vimeo.com'].includes(urlObj.hostname);
    } catch (e) {
      console.log(`******errror=${e}`);
      return false; // Not vimeo URL
    }
  };
  const setVideoParams = (embedUrl) => {
      //Add autoplay and controls parameters
      if (!embedUrl.searchParams.has('autoplay')) {
        embedUrl.searchParams.set('autoplay', '1');
      }
      //add controls parameter if not present
      if (!embedUrl.searchParams.has('controls')) {
        embedUrl.searchParams.set('controls', '0');
      }

      //add mute parameter if not present
      if (!embedUrl.searchParams.has('mute')) {
        embedUrl.searchParams.set('mute', '1');
      }
  };
  const convertYoutubeToEmbedUrl = (urlObj) => {
     try {  
      if (urlObj.pathname.startsWith('/embed/')){
        setVideoParams(urlObj);
        return urlObj.toString();
      }
      let videoId = '';
      if (urlObj.hostname === 'youtu.be') {
        // https://youtu.be/VIDEO_ID
        videoId = urlObj.pathname.slice(1);
      } else {
        // https://www.youtube.com/watch?v=VIDEO_ID
        videoId = urlObj.searchParams.get('v') || 
                urlObj.pathname.split('/').pop();
      }      
      if (!videoId || videoId.length !== 11) return null; // YouTube video ID should be 11 characters long

      //create new embed URL
      const embedUrl = new URL(`https://www.youtube.com/embed/${videoId}`);
      
      // keep original query parameters except 'v'
      urlObj.searchParams.forEach((value, key) => {
        if (key === 't') {
          embedUrl.searchParams.set('start', value);
        } 
        //exclude 'v' parameter from the embed URL
        else if (key !== 'v') {
          embedUrl.searchParams.set(key, value);
        }
      });
      
      // Handling timestamps in hashes (for example #t=1m30s)
      if (urlObj.hash) {
          const hashMatch = urlObj.hash.match(/t=(\d+m)?(\d+s)?/);
          if (hashMatch) {
            const minutes = hashMatch[1] ? parseInt(hashMatch[1]) : 0;
            const seconds = hashMatch[2] ? parseInt(hashMatch[2]) : 0;
            embedUrl.searchParams.set('start', minutes * 60 + seconds);
          }
      }
      setVideoParams(embedUrl);
      return embedUrl.toString();
    } catch (e) {
      return null;
    }
  };
  const convertVimeoToEmbedUrl = (urlObj) => {
    try {
      if (urlObj.href.includes('player.vimeo.com/video/') && urlObj.hostname.includes('player.vimeo.com')) {
        console.log(`Already an embed URL: ${urlObj.href}`);
        setVideoParams(urlObj);
        return urlObj.toString();
      }
      let videoId = '';

      //https://vimeo.com/VIDEO_ID?fl=wc
      //https://vimeo.com/VIDEO_ID?share=copy#t=36.691
      videoId = urlObj.pathname.split('/').pop();    
      if (!videoId) return null;

      //create new embed URL
      const embedUrl = new URL(`https://player.vimeo.com/video/${videoId}`);
      
      // keep original query parameters except 'v'
      urlObj.searchParams.forEach((value, key) => {
        if (key === 't') {
          embedUrl.searchParams.set('start', value);
        }
        else {
          embedUrl.searchParams.set(key, value);
        }
      });

      setVideoParams(embedUrl);
      // Handling timestamps in hashes (for example #t=1m30s)
      if (urlObj.hash) {
        /*const hashMatch = urlObj.hash.match(/#t=(\d+m)?(\d+s)?/);
        if (hashMatch) {
          if(hashMatch[1] || hashMatch[2]){
            const minutes = hashMatch[1] ? parseInt(hashMatch[1]) : 0;
            const seconds = hashMatch[2] ? parseInt(hashMatch[2]) : 0;
            embedUrl.searchParams.set('#start', minutes * 60 + seconds);
          }else{
            embedUrl.searchParams.set('#start', urlObj.hash.slice(3)); // Remove the '#t=' character
          }
        }*/
        if(urlObj.hash.startsWith('#t=')){
          return embedUrl.toString() + urlObj.hash; // Append the original hash to the embed URL
        }
      }
      return embedUrl.toString();
    } catch (e) {
      return null;
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);

    const nameError = validateField(name, 'name');
    const linkError = mode === SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.LINK ? validateField(link) : '';
    const embedCodeError = mode === SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.CODE ? validateField(embedCode) : '';

    if (nameError || linkError || embedCodeError) {
      setNameValid(nameError);
      setLinkValid(linkError);
      setEmbedCodeValid(embedCodeError);
      setModalError(<FormattedMessage id="SUBMIT_ERROR" />);
      return;
    }

    try {
      let embedUrl = null;
      if(mode === SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.LINK && link) {
        const urlObj = new URL(link);       
        if (isYouTubeUrl(urlObj)) {
          embedUrl = convertYoutubeToEmbedUrl(urlObj);
        }else if (isVimeoUrl(urlObj)) {
          embedUrl = convertVimeoToEmbedUrl(urlObj);
        }
        console.log(`11111  link= ${urlObj} embedUrl new link=${embedUrl}`);
      }

      const formData = {
        category: SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.LINK,
        subcategory: mode,
        type: type,
        name: name,
        content: mode === SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.LINK
          ? { urls: embedUrl ? [embedUrl] : [link] }
          : { embedCode: embedCode }
      };

      if (linkItem) {
        formData.id = linkItem.id;
        await API.updateMedia(formData);
        updatePlaylistsMedia(formData);
        setSuccess(<FormattedMessage id="EDIT_LINK_SUCCESS" />);
      } else {
        await API.addMedia(formData);
        setSuccess(<FormattedMessage id="ADD_LINK_SUCCESS" />);
      }
      refreshData();
      closeModal("addLinkModal");
    } catch (err) {
      const errorMessageId = linkItem ? "EDIT_LINK_FAILED" : "ADD_LINK_FAILED";
      setModalError(<FormattedMessage id={errorMessageId} values={{ errorMsg: <b>{err.message}</b> }} />);
    }
  };

  return (
    <div className='modal modal-mse fade' id='addLinkModal' tabIndex='-1' aria-labelledby='addLinkModalLable' aria-hidden='true'>
      <div className='modal-dialog modal-dialog-centered'>
        <div className='modal-content modal-mes-content'>
          <div className='modal-header modal-mes-header' style={{ backgroundColor: '#347BFA' }}>
            <h5 className='modal-title modal-mes-title'>{linkItem ? <FormattedMessage id='EDIT_LINK' /> : <FormattedMessage id='ADD_LINKS' />}</h5>
            <button id="closeModal" type='button' className='btn-close' data-bs-dismiss='modal' aria-label='Close'></button>
          </div>
          <div className='modal-body'>
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-12">
                  <label htmlFor="addLinkName" className="font-weight-600 font-size-14 mb-2">
                    <FormattedMessage id="LINK_NAME" defaultMessage="Name" />:
                  </label>
                  <input
                    id="addLinkName"
                    className={`form-control h-54 bg-baby-blue ${submitted && (nameValid ? 'is-invalid' : 'is-valid')}`}
                    value={name}
                    onChange={handleChangeName}
                    name="addLinkName"
                    placeholder={intl.formatMessage({ id: "LINK_NAME", defaultMessage: "Name" })}
                  />
                  {commonFunctions.InvalidFeedbackString(nameValid, 'LINK_NAME')}
                </div>
              </div>
              <div className="row">
                <div className="col-12 mt-4">
                  <label className="font-weight-600 font-size-14">
                    <FormattedMessage id="LINK_SELECT" defaultMessage="Select" />:
                  </label>
                  <RadioCheck
                    options={{ [SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.LINK]: "LINK", [SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.CODE]: "LINK_EMBEDDED_CODE" }}
                    name="LINK_SELECT"
                    selectedOption={mode}
                    onChange={e => setMode(e.target.value)}
                  />
                </div>
              </div>
              {mode === SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.LINK && (
                <>
                  <div className="row">
                    <div className="col-12 mt-4">
                      <label className="font-weight-600 font-size-14">
                        <FormattedMessage id="SELECT_TYPE_LINK:" defaultMessage="Select Type Of Link" />:
                      </label>
                      <RadioCheck
                        options={typeLinkOptions}
                        name="SELECT_TYPE_LINK"
                        selectedOption={type}
                        onChange={e => setType(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="mt-4">
                      <label className="font-weight-600 font-size-14 mb-2">
                        <FormattedMessage id="LINK" defaultMessage="Link" />:
                      </label>
                      <input
                        className={`form-control h-54 bg-baby-blue ${submitted && (linkValid ? 'is-invalid' : 'is-valid')}`}
                        value={link}
                        onChange={handleChangeLink}
                        name="addLinkInput"
                        placeholder={intl.formatMessage({ id: "LINK", defaultMessage: "Link" })}
                      />
                      {commonFunctions.InvalidFeedbackString(linkValid, 'LINK')}
                    </div>
                  </div>
                </>
              )}
              {mode === SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.CODE && (
                <div className="row mt-3">
                  <div className="mb-2 col-12">
                    <textarea
                      className={`form-control h-54 bg-baby-blue ${submitted && (embedCodeValid ? 'is-invalid' : 'is-valid')}`}
                      style={{ height: 104 }}
                      value={embedCode}
                      onChange={handleChangeEmbedCode}
                      name="addEmbedCode"
                      placeholder={intl.formatMessage({ id: "LINK_EMBEDDED_CODE", defaultMessage: "Embedded Code" })}
                    />
                    {commonFunctions.InvalidFeedbackString(embedCodeValid, 'LINK_EMBEDDED_CODE')}
                  </div>
                </div>
              )}
              {submitted && modalError && (
                <div className='modal-error invalid-feedback d-block fw-bold text-center mt-3'>
                  {modalError}
                </div>
              )}
            </form>
          </div>
          <div className='modal-footer modal-mes-footer d-flex align-items-center'>
            <button id="backGroupModalBtn" type='button' className='btn btn-outline-secondary me-3' data-bs-dismiss='modal'>
              <FormattedMessage id='CANCEL' />
            </button>
            <button id="saveGroupBtn" className='btn btn-primary but-darkblue' type='button' onClick={handleSubmit}>
              {linkItem ? <FormattedMessage id='EDIT_LINK' /> : <FormattedMessage id='ADD_LINKS' />}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddLink;